import { apiRequest } from '@/utils/request';
import { ListProps } from 'antd/lib/list';

async function getPermissions(): Promise<ListProps<any>> {
  const data: any = await apiRequest(`/roles/permissions`);
  return { ...data, data: data.items, total: data.meta.totalItems };
}

export default { getPermissions };
